"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomBytes = void 0;

var helpers_1 = require("./helpers");

function randomBytes(length) {
  if (!helpers_1.isValidKeyLength(length)) {
    throw new Error("randomBytes - invalid key length: ".concat(length));
  }

  var result;

  if (helpers_1.isBrowser()) {
    result = helpers_1.browserRandomBytes(length);
  } else if (helpers_1.isNode()) {
    result = helpers_1.nodeRandomBytes(length);
  } else {
    result = helpers_1.fallbackRandomBytes(length);
  }

  return result;
}

exports.randomBytes = randomBytes;
exports.default = randomBytes;